import * as _ from 'lodash';

import {
  LedgerTransactionGQLType,
  OrganizationGQLType,
  TransactionTypeGQLType,
} from '../../../../types/dashboard-core-gqlTypes.generated.d';

export interface LedgerTransactionWithName extends LedgerTransactionGQLType {
  transactionName: string;
  capitalProviderName: string;
  dailyBalance: number;
}

const ledgerTransactionTypeToLabelConfig: Partial<
  Record<TransactionTypeGQLType, string>
> = {
  drawRequest: 'Draw request',
  collectionsPaydown: 'Collections paydown',
  curePaydown: 'Cure paydown',
  increaseOutstandingLoanBalance: 'Manual credit',
  decreaseOutstandingLoanBalance: 'Manual debit',
};

export const allLedgerTransactionTypes = _.keys(
  ledgerTransactionTypeToLabelConfig,
) as TransactionTypeGQLType[];

export const transactionTypeOptions = _.map(
  ledgerTransactionTypeToLabelConfig,
  (ledgerTransactionType, key) => {
    return {
      value: key as TransactionTypeGQLType,
      label: ledgerTransactionType as string,
    };
  },
);

const transactionTypeToNameConfig: {
  [key in TransactionTypeGQLType]: string;
} = {
  drawRequest: 'Draw request',
  collectionsRecycle: 'Collections recycle',
  collectionsPaydown: 'Collections paydown',
  curePaydown: 'Cure paydown',
  expensePayment: 'Expense payment',
  increaseCurrentLiability: 'Manual credit',
  increaseExpensePayment: 'Expense payment',
  increaseOutstandingLoanBalance: 'Manual credit',
  decreaseCurrentLiability: 'Manual debit',
  decreaseExpensePayment: 'Decrease expense payment',
  decreaseOutstandingLoanBalance: 'Manual debit',
  dailyAccrual: 'Daily accrual',
  reverseInterestAccrual: 'Reverse interest accrual',
  reconciliationAdjustment: 'Reconciliation Adjustment',
  zeroCurrentLiabilities: 'Zero current liabilities',
  invoiceLoanPayment: 'Invoice loan payment',
  reverseInvoiceLoanPayment: 'Reverse invoice loan payment',
  interestCapitalization: 'Interest capitalization',
  reverseInterestCapitalization: 'Reverse interest capitalization',
  invoiceFacilityPayment: 'Invoice facility payment',
  reverseInvoiceFacilityPayment: 'Reverse invoice facility payment',
  adminAgentPrincipalLending: 'Admin Agent Lending',
  adminAgentPrincipalPaydown: 'Admin Agent Paydown',
  reverseAdminAgentPrincipalPaydown: 'Reverse Admin Agent Paydown',
  transferPrincipalBalance: 'Transfer Principal Balance',
};

export const formatLedgerTransactions = (
  capitalProviders: Pick<OrganizationGQLType, 'id' | 'name'>[],
  transactions?: LedgerTransactionGQLType[],
): LedgerTransactionWithName[] => {
  if (!transactions) {
    return [];
  }
  const capitalProvidersConfig = _.keyBy(capitalProviders, 'id');

  // get the total daily balance for each postingDate by the last transaction on that postingDate
  const totalBalanceByDay = _.keyBy(transactions, 'postingDate');

  const descendingTransactions = _.reverse(_.clone(transactions));
  const descendingTransactionsWithName = _.map(
    descendingTransactions,
    (descendingTransaction) => {
      return {
        ...descendingTransaction,
        transactionName:
          transactionTypeToNameConfig[descendingTransaction.transactionType],
        capitalProviderName:
          capitalProvidersConfig[descendingTransaction.organizationId].name,
        dailyBalance:
          totalBalanceByDay[descendingTransaction.postingDate].balance,
      };
    },
  );

  return descendingTransactionsWithName;
};
